import type { ClientLayoutConfig } from '@/entities/client-config/model/clientConfig.types'
import { createColumnConfig } from '@/widgets/orders-board/orders-board.config'

const DASHBOARD_COLUMNS = [
  createColumnConfig('DeliveringToCustomer', {
    emptyMessage: 'No orders are being delivered',
    className: 'section-delivering',
    dataOnboarding: 'section-delivering',
    name: 'DeliveringToCustomer',
    states: ['DeliveringToCustomer', 'Delivery'],
    mobileViewComponent: 'compactOrderCardCarousel',
  }),
  createColumnConfig('Arrived', {
    emptyMessage: 'No orders have arrived',
    className: 'section-arrived',
    dataOnboarding: 'section-arrived',
    name: 'Arrived',
    states: ['Arrived'],
    mobileViewComponent: 'default',
  }),
  createColumnConfig('OnTheWay', {
    emptyMessage: 'No orders are on the way',
    className: 'section-on-the-way',
    dataOnboarding: 'section-on-the-way',
    name: 'OnTheWay',
    states: ['OnTheWay', 'TempoOnTheWay', 'PartnerOnTheWay'],
    mobileViewComponent: 'default',
  }),
]

export const layoutConfig: ClientLayoutConfig = {
  middle: {
    columns: DASHBOARD_COLUMNS,
    columnOrder: 'row-reverse',
  },
  bottom: {
    enabled: true,
    components: [
      {
        id: 'ready-to-collect',
        type: 'carousel',
        includedStatuses: ['ReadyToCollect'],
        emptyMessage: 'No orders are ready to collect',
      },
    ],
  },
}
